import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";
import { Link } from "react-router-dom";
import useSiteContent from "@/hooks/useSiteContent";

export default function FAQ() {
  const cms = useSiteContent();
  const faqs = cms.faqs?.length ? cms.faqs : FAQS;
  return (
    <>
      <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="chapter-num">Frequently Asked</div>
          <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Questions,<br /><em className="italic text-[var(--pta-gold)]">answered.</em></h1>
        </div>
      </section>
      <section className="bg-[var(--pta-cream)] pb-24">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`f-${i}`} className="border-b hairline">
                <AccordionTrigger data-testid={`faq-${i}`} className="text-left py-6 font-serif-display text-xl md:text-2xl text-[var(--pta-navy)] hover:text-[var(--pta-gold)]"><span className="flex items-baseline gap-4"><span className="font-mono-fine text-xs text-[var(--pta-gold)]">{String(i+1).padStart(2,'0')}</span>{f.q}</span></AccordionTrigger>
                <AccordionContent className="pb-6 text-[var(--pta-ink)]/75 text-base leading-relaxed pl-9">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="mt-14 border hairline-navy p-8 text-center">
            <p className="font-serif-display text-2xl md:text-3xl text-[var(--pta-navy)]">Still have questions?</p>
            <div className="mt-6 flex gap-3 justify-center flex-wrap">
              <Link to="/book" data-testid="faq-book" className="btn-pta">Book Free Consultation</Link>
              <Link to="/contact" data-testid="faq-contact" className="btn-pta-outline">Write to Us</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
